module.exports = __webpack_public_path__ + "static/img/icon-floor-item-4.b350ddf8.png";